module.exports = __webpack_public_path__ + "img/investment.76cc1f29.svg";